<template>
  <div class="administration">
    <div class="container is-fluid">
      <div class="columns is-multiline">
        <div class="column is-2 is-12-touch">
          <b-menu>
            <b-menu-list label="Administration">
              <b-menu-item
                icon="poll"
                label="Statistik"
                exact
                tag="router-link"
                :to="{ name: 'administration' }"
              />

              <b-menu-item
                icon="account-multiple"
                exact
                expanded
                tag="router-link"
                :to="{ name: 'administration.students.active' }"
              >
                <template slot="label" slot-scope="props">
                  Studerende (aktive)
                </template>

                <b-menu-item
                  label="Alle"
                  exact
                  tag="router-link"
                  :to="{ name: 'administration.students' }"
                />

                <b-menu-item
                  label="Ny fra sign-up"
                  tag="router-link"
                  :to="{ name: 'administration.students.new' }"
                />

                <b-menu-item
                  label="Ansøgninger"
                  tag="router-link"
                  :to="{ name: 'administration.students.applications' }"
                />
              </b-menu-item>

              <b-menu-item
                icon="account-cash"
                exact
                expanded
                tag="router-link"
                :to="{ name: 'administration.customers' }"
              >
                <template slot="label" slot-scope="props">
                  Kunder
                </template>

                <b-menu-item
                  label="Med aktive projekter"
                  exact
                  tag="router-link"
                  :to="{ name: 'administration.customers.activeProjects' }"
                />
              </b-menu-item>

              <b-menu-item
                icon="clipboard-check"
                exact
                expanded
                tag="router-link"
                :to="{ name: 'administration.projects' }"
              >
                <template slot="label" slot-scope="props">
                  Projekter
                </template>
                <b-menu-item
                  label="Igangværende"
                  exact
                  expanded
                  tag="router-link"
                  :to="{ name: 'administration.projects.open' }"
                >
                  <b-menu-item
                    label="Projekt oprettet"
                    exact
                    tag="router-link"
                    :to="{ name: 'administration.projects.project-created' }"
                  />
                  <b-menu-item
                    label="Projekt afklares"
                    exact
                    tag="router-link"
                    :to="{ name: 'administration.projects.project-clarification' }"
                  />
                  <b-menu-item
                    label="Tilbud afgivet"
                    exact
                    tag="router-link"
                    :to="{ name: 'administration.projects.project-offer-posted' }"
                  />
                  <b-menu-item
                    label="Tilbud accepteret"
                    exact
                    tag="router-link"
                    :to="{ name: 'administration.projects.project-offer-accepted' }"
                  />
                </b-menu-item>

                <b-menu-item
                  label="Afsluttede projekter"
                  exact
                  expanded
                  tag="router-link"
                  :to="{ name: 'administration.projects.closed' }"
                >
                               
                    <b-menu-item
                    label="Medarbejder afslutter"
                    exact
                    tag="router-link"
                    :to="{ name: 'administration.projects.employee-closed-project' }"
                  />
                    <b-menu-item
                    label="Student afslutter"
                    exact
                    tag="router-link"
                    :to="{ name: 'administration.projects.student-closed-project' }"
                  />
                    <b-menu-item
                    label="Kunde afslutter"
                    exact
                    tag="router-link"
                    :to="{ name: 'administration.projects.customer-closed-project' }"
                  />
                    <b-menu-item
                    label="Projekt færdiggjort"
                    exact
                    tag="router-link"
                    :to="{ name: 'administration.projects.project-finalized' }"
                  />
              </b-menu-item>
              </b-menu-item>

              <b-menu-item
                icon="face-agent"
                label="Ansatte"
                exact
                tag="router-link"
                :to="{ name: 'administration.employees' }"
              />
            </b-menu-list>
          </b-menu>
        </div>

        <div class="column is-10 is-12-touch">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.administration {
  background: #f5f7fa;
  padding: 1rem 0;
}
</style>

<script>
import PageTop from '@/global/components/PageTop'

export default {
  data () {
    return {}
  },

  methods: {},

  components: {
    PageTop
  }
}
</script>



// WEBPACK FOOTER //
// src/taskflex/administration/pages/Administration.vue